/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ExcludeAppointmentDayResponse } from './ExcludeAppointmentDayResponse';
import {
    ExcludeAppointmentDayResponseFromJSON,
    ExcludeAppointmentDayResponseFromJSONTyped,
    ExcludeAppointmentDayResponseToJSON,
    ExcludeAppointmentDayResponseToJSONTyped,
} from './ExcludeAppointmentDayResponse';

/**
 * 
 * @export
 * @interface ResultOfExcludeAppointmentDayResponse
 */
export interface ResultOfExcludeAppointmentDayResponse {
    /**
     * 
     * @type {ExcludeAppointmentDayResponse}
     * @memberof ResultOfExcludeAppointmentDayResponse
     */
    data: ExcludeAppointmentDayResponse | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResultOfExcludeAppointmentDayResponse
     */
    isSuccess: boolean;
    /**
     * 
     * @type {Error}
     * @memberof ResultOfExcludeAppointmentDayResponse
     */
    error: Error | null;
}

/**
 * Check if a given object implements the ResultOfExcludeAppointmentDayResponse interface.
 */
export function instanceOfResultOfExcludeAppointmentDayResponse(value: object): value is ResultOfExcludeAppointmentDayResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('isSuccess' in value) || value['isSuccess'] === undefined) return false;
    if (!('error' in value) || value['error'] === undefined) return false;
    return true;
}

export function ResultOfExcludeAppointmentDayResponseFromJSON(json: any): ResultOfExcludeAppointmentDayResponse {
    return ResultOfExcludeAppointmentDayResponseFromJSONTyped(json, false);
}

export function ResultOfExcludeAppointmentDayResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfExcludeAppointmentDayResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ExcludeAppointmentDayResponseFromJSON(json['data']),
        'isSuccess': json['isSuccess'],
        'error': json['error'],
    };
}

export function ResultOfExcludeAppointmentDayResponseToJSON(json: any): ResultOfExcludeAppointmentDayResponse {
    return ResultOfExcludeAppointmentDayResponseToJSONTyped(json, false);
}

export function ResultOfExcludeAppointmentDayResponseToJSONTyped(value?: ResultOfExcludeAppointmentDayResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ExcludeAppointmentDayResponseToJSON(value['data']),
        'isSuccess': value['isSuccess'],
        'error': value['error'],
    };
}

